module.exports = __webpack_public_path__ + "static/media/turks-and-caicos.4993f68e.png";